import { ROLE_META, type SimulatorRole } from '../thread/roles';

/** Squarish role choice: stacked icon + label, with the segmented tabs' hover language. */
export const RoleTile = ({ role, onSelect }: { role: SimulatorRole; onSelect?: (role: SimulatorRole) => void }) => {
  const meta = ROLE_META[role];
  return (
    <button
      type='button'
      onClick={() => onSelect?.(role)}
      className='group flex h-16 w-24 flex-col items-center justify-center gap-1.5 rounded-lg border border-gray-500 bg-white text-xs leading-4 font-medium text-text-heading transition-shadow hover:inset-ring-1 hover:inset-ring-gray-600'
    >
      <meta.icon
        strokeWidth={1.5}
        aria-hidden
        className='size-4.5 transition-transform duration-200 ease-out group-hover:scale-110 motion-reduce:transition-none motion-reduce:group-hover:scale-100'
      />
      {meta.label}
    </button>
  );
};
